import React from "react";
import "./SignInButton.css";
import { login } from "../../utils/msalAuth";
import { FormattedMessage } from "react-intl";

const SignInButton = () => {
  return (
    <button className="sign-in-button" onClick={login}>
      <FormattedMessage id="login.button" defaultMessage="Login-Bayer Users" />
    </button>
  );
};

export default SignInButton;
